// Native scrollIntoView also pans the hidden outer page on desktop, leaving
// the header above the viewport and blank space below the document.
export function revealSection(section) {
  if (!section?.isConnected) return
  const editor = section.querySelector('.ProseMirror')
  const target = editor || section
  const content = section.closest('.editor-content')
  const toolbar = content?.querySelector('.tiptap-fixed-toolbar')
  let owner = content
  let fallback = null
  while (owner && owner !== document.body && owner !== document.documentElement) {
    if (/^(auto|scroll)$/.test(getComputedStyle(owner).overflowY)) {
      fallback = fallback || owner
      if (owner.scrollHeight > owner.clientHeight) break
    }
    owner = owner.parentElement
  }
  if (owner === document.body || owner === document.documentElement) owner = fallback

  const top = Math.max(0, owner?.getBoundingClientRect().top || 0, toolbar?.getBoundingClientRect().bottom || 0) + 8
  const bottom = Math.min(innerHeight, owner?.getBoundingClientRect().bottom || innerHeight)
  const rect = target.getBoundingClientRect()
  const adjustment = rect.top - top - Math.max(0, (bottom - top - rect.height) / 2)
  if (owner) owner.scrollTop += adjustment
  else window.scrollBy(0, adjustment)
  editor?.focus({ preventScroll: true })
}
